import script from "./FilterVecinos.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterVecinos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__